<template>
    <div class="nav-component">
        <!-- <div id="nav-component">
            <img :src="mainLogo" alt="" class="headlogo">
            <a-menu v-model="current" mode="horizontal" style="margin:0 0 0 214px;">
                <a-menu-item key="ScriptSquare">
                    <router-link to="/ScriptSquare">
                        <a-icon type="robot" />话术广场
                    </router-link>
                </a-menu-item>
                <a-menu-item key="MyProject">
                    <router-link to="/MyProject">
                        <a-icon type="snippets" />我的项目
                    </router-link>
                </a-menu-item>
                <a-menu-item key="Statistics" @click="jumpTo()">
                    <a-icon type="database" />数据监控
                </a-menu-item>
                <a-menu-item key="Dialogues">
                    <router-link to="/Dialogues">
                        <a-icon type="robot" />对话记录
                    </router-link>
                </a-menu-item>
                <a-menu-item key="DataView">
                    <router-link to="/DataView">
                        <a-icon type="credit-card" />数据标签
                    </router-link>
                </a-menu-item>
            </a-menu>
            <LoginState></LoginState>
        </div> -->
        <div class="left-menu">
            <div class="headlogo">
                <img :src="mainLogo" alt="">
            </div>
            <div style="flex:1;display: flex;flex-direction: column;padding:0 16px;overflow-y:auto;width:240px;">
                <a-input-search
                    placeholder="请输入项目名称"
                    @search="onSearch" 
                />
                <div class="menu-list" style="margin-top:16px" :class="currentMenu=='MyAttention'?'active-menu':''" @click="jumpTo('MyAttention')">
                    <a-icon type="heart" />我的关注
                </div>
                <div class="menu-list" :class="currentMenu=='ScriptSquare'?'active-menu':''" @click="jumpTo('ScriptSquare')">
                    <a-icon type="robot" />共享模板
                </div>
                <a-divider style="color:rgba(229, 229, 229, 1);margin:16px 0" />
                <div class="menu-box">
                    <div class="menu-tab" style="font-weight:bold" :class="currentMenu=='MyProject'?'active-menu':''" @click="goMyPro('MyProject')">
                        <a-icon type="appstore" />
                        <span>我的项目</span>
                    </div>
                    <div class="menu-tab menu-tab-list" @click="selectCurrentTab('outCallSence')">
                        <a-icon type="customer-service" theme="filled" />
                        <span>智能电话</span>
                        <span>({{ proObj.outCallSence.length }})</span>
                        <a-icon v-if="currentSelectTab!='outCallSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="right" />
                        <a-icon v-if="currentSelectTab=='outCallSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="down" />
                    </div>
                    <ul v-if="currentSelectTab=='outCallSence'">
                        <li @click="viewDetailPro(item.id)" :class="{'current-active':currentSelectId==item.id}" v-for="(item,index) in proObj.outCallSence" :title="item.name" style="overflow:hidden;height:30px;" :key="index">
                            {{ item.name }}
                        </li>
                    </ul>
                    <div class="menu-tab menu-tab-list" @click="selectCurrentTab('chatgptSence')">
                        <a-icon type="android" theme="filled" />
                        <span>Chatgpt助手</span>
                        <span>({{ proObj.chatgptSence.length }})</span>
                        <a-icon v-if="currentSelectTab!='chatgptSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="right" />
                        <a-icon v-if="currentSelectTab=='chatgptSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="down" />
                    </div>
                    <ul v-if="currentSelectTab=='chatgptSence'">
                        <li @click="viewDetailGpt(item.id)" :class="{'current-active':currentSelectId==item.id}" v-for="(item,index) in proObj.chatgptSence" :title="item.name" style="overflow:hidden;height:30px;" :key="index">
                            {{ item.name }}
                        </li>
                    </ul>
                    <div class="menu-tab menu-tab-list" @click="selectCurrentTab('wordSence')">
                        <a-icon type="contacts" theme="filled" />
                        <span>文字客服</span>
                        <span>({{ proObj.wordSence.length }})</span>
                        <a-icon v-if="currentSelectTab!='wordSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="right" />
                        <a-icon v-if="currentSelectTab=='wordSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="down" />
                    </div>
                    <ul v-if="currentSelectTab=='wordSence'">
                        <li v-for="(item,index) in proObj.wordSence" :key="index">
                            {{ item.name }}
                        </li>
                    </ul>
                    <div class="menu-tab menu-tab-list" @click="selectCurrentTab('videoSence')">
                        <a-icon type="play-square" theme="filled" />
                        <span>视频客服</span>
                        <span>({{ proObj.videoSence.length }})</span>
                        <a-icon v-if="currentSelectTab!='videoSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="right" />
                        <a-icon v-if="currentSelectTab=='videoSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="down" />
                    </div>
                    <ul v-if="currentSelectTab=='videoSence'">
                        <li v-for="(item,index) in proObj.videoSence" :key="index">
                            {{ item.name }}
                        </li>
                    </ul>
                    <div class="menu-tab menu-tab-list" @click="selectCurrentTab('digitalHumanSence')">
                        <a-icon type="usb" theme="filled" />
                        <span>H5数字人</span>
                        <span>({{ proObj.digitalHumanSence.length }})</span>
                        <a-icon v-if="currentSelectTab!='digitalHumanSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="right" />
                        <a-icon v-if="currentSelectTab=='digitalHumanSence'" style="color:rgba(158, 172, 196, 1);float:right;font-size:12px;margin-top:14px;" type="down" />
                    </div>
                    <ul v-if="currentSelectTab=='digitalHumanSence'">
                        <li v-for="(item,index) in proObj.digitalHumanSence" :key="index">
                            {{ item.name }}
                        </li>
                    </ul>
                    <a-divider style="color:rgba(229, 229, 229, 1);margin:16px 0" />
                    <div class="menu-tab" style="font-weight:bold" :class="currentMenu=='RecycleBin'?'active-menu':''" @click="goRecycleBin('RecycleBin')">
                        <a-icon type="message" />
                        <span>回收站</span>
                        <span>({{ deleteProList.length }})</span>
                    </div>
                </div>
            </div>
            <a-divider class="menu-divider" />
            <div class="login-out">
                <!-- <img class="login-img" src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" alt=""> -->
                <a-avatar class="login-img" size="small" :src="personalData.avatar"/>
                <div class="login-info">
                    {{ personalData.name }}
                </div>
                <a-icon class="login-icon" type="right" />
                <div class="personal-menu">
                    <ul>
                        <li @click="goToPersonal">
                            <a-icon type="user"/>
                            <span>个人中心</span>
                            <a-divider class="personal-divider" />
                        </li>
                        <li @click="goToMiddleCenter">
                            <a-icon type="appstore"/>
                            <span>用户后台</span>
                            <a-divider class="personal-divider" />
                        </li>
                        <li @click="goProductCommunity">
                            <a-icon type="laptop" />
                            <span>产品社区</span>
                            <a-divider class="personal-divider" />
                        </li>
                        <li @click="handleLogout">
                            <a-icon type="poweroff"/>
                            <span>退出登录</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="right-body">
            <div class="head-title">
                <div class="head-title-list" v-if="currentMenu=='MyProject'&&currentType==1">
                    <a-icon type="cloud" />
                    <span>我的项目 ({{proList.length}})</span>
                </div>
                <div class="head-title-list" v-if="currentMenu=='ScriptSquare'">
                    <a-icon type="codepen-circle" />
                    <span>话术广场</span>
                </div>
                <div @click="backToMenu('MyProject', 1)" class="head-title-list" v-if="currentMenu=='MyProject'&&currentType==2">
                    <a-icon type="arrow-left" />
                    <span>返回我的项目</span>
                </div>
                <div class="head-title-list" v-if="currentMenu=='MyProject'&&currentType==3">
                    <a-icon type="arrow-left" />
                    <span>返回呼叫对接</span>
                </div>
                <div @click="backToMenu('MyProject', 1)" class="head-title-list" v-if="currentMenu=='MyProject'&&currentType==4">
                    <a-icon type="arrow-left" />
                    <span>返回工作台</span>
                </div>
                <div class="head-title-list" style="cursor:default" v-if="currentMenu=='RecycleBin'">
                    <span>回收站</span>
                </div>
                <div class="head-title-list" style="cursor:default" v-if="currentMenu=='MyAttention'">
                    <span>我的关注</span>
                </div>
            </div>
            <div class="body-content">
                <router-view @changeFatherData="changeFatherData" @changeId="changeId" @changeAttention="changeAttention" :personalName="personalData.name" ref="sonMethod" ></router-view>
            </div>
        </div>
    </div>
</template>
<script>
    // import LoginState from './head/LoginState';
    export default {
        name: 'Nav',
        data() {
            return {
                mainLogo: '',
                pageTitle: '',
                faviconIcon: '',
                currentMenu: '',
                keyword: '',
                proObj: {
                    myAttention: [],
                    outCallSence: [],
                    wordSence: [],
                    videoSence: [],
                    digitalHumanSence: [],
                    chatgptSence: []
                },
                currentSelectTab: 'myAttention',
                deleteProList: [],
                proList: [],
                currentType: 1,
                pageContent: 'project',
                personalData: {
                    id: '',
                    avatar: '',
                    createTime: '',
                    introduction: '',
                    name: ''
                },
                currentSelectId: ''
            }
        },
        components: {
            // LoginState,
        },
        methods:{
            viewDetailPro(item) {
                let data = JSON.stringify(item)
                this.$router.push({
                    path:'/ProDetail',
                    query: {
                        id: data
                    }
                })
                this.currentSelectId = item
                sessionStorage.setItem('currentSelectId', data)
                window.location.reload()
            },
            jumpTo(url) {
                if(url == 'MyAttention'){
                    this.resetSetItem('currentMenu','MyAttention');
                    this.$router.push({path: '/MyProject',query:{isAttention:true}});
                    window.location.reload()
                }else if(url == 'ScriptSquare'){
                    this.resetSetItem('currentMenu','ScriptSquare');
                    this.$router.push('/' + url)
                }
                this.currentMenu = url
                this.currentType = 1
            },
            queryBasicInfo() {
                let host = window.location.host
                this.axios(
                    {
                    method:'get',
                    url:'/api/login/loginInfo', 
                    params: {
                        hostName: host,
                    }
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.mainLogo = response.data.data.mainLogo
                        this.pageTitle = response.data.data.sysName
                        this.faviconIcon = response.data.data.titleLogo
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryAllProList(type) {
                this.axios(
                    {
                        method:'get',
                        url:'/api/project/list', 
                        params: {
                            keyword: this.keyword,
                            status: '',
                            type: '',
                            hasDelete: type
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let arr = response.data.data
                        if(type){
                            this.deleteProList = response.data.data
                        }else{
                            this.proObj = {
                                myAttention: [],
                                outCallSence: [],
                                wordSence: [],
                                videoSence: [],
                                digitalHumanSence: [],
                                chatgptSence: []
                            }
                            for(let i = 0; i < arr.length; i++){
                                if(arr[i]['purpose'] == 1){
                                    this.proObj['outCallSence'].push(arr[i])
                                }else if(arr[i]['purpose'] == 2){
                                    this.proObj['wordSence'].push(arr[i])
                                }else if(arr[i]['purpose'] == 3){
                                    this.proObj['videoSence'].push(arr[i])
                                }else if(arr[i]['purpose'] == 4){
                                    this.proObj['digitalHumanSence'].push(arr[i])
                                }else if(arr[i]['purpose'] == 5){
                                    this.proObj['chatgptSence'].push(arr[i])
                                }
                            }
                            this.proList = response.data.data
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            onSearch(value) {
                this.keyword = value
                this.queryAllProList(false) 
            },
            goToMiddleCenter() {
                let host = window.location.host
                this.axios(
                    {
                        method:'get',
                        url:'/api/intelligence/superLoginUrl', 
                        params: {
                            hostName: host
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let url = response.data.data.superLoginUrl
                        window.open(url, '_blank');
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error);
                })
            },
            selectCurrentTab(param){
                if(this.currentSelectTab == param){
                    this.currentSelectTab = ''
                    this.sessionData('set','currentSelectTab','');
                }else{
                    this.currentSelectTab = param
                    this.sessionData('set','currentSelectTab',param);
                }
                if(param == 'recycleBin'){
                    this.$router.push('/recycleBin')
                    this.currentType = 1
                    setTimeout(()=>{
                        this.$refs.sonMethod.ifRecycleBin = true
                        this.$refs.sonMethod.queryDeleteProList()   
                    })
                }
            },
            changeAttention(val){
                this.queryAllProList(val)
            },
            changeFatherData(data) {
                this.currentMenu = 'MyProject'
                this.currentType = data
            },
            changeId(data) {
                this.currentSelectId = data
            },
            backToMenu(data, type) {
                this.$router.push('/' + data)
                this.currentType = type
                this.pageContent = 'project'
            },
            handleLogout () {
                this.$confirm({
                    title: '提示',
                    content: '真的要注销登录吗？',
                    okText: "确认",
                    cancelText: "取消",
                    onOk: () => {
                        this.$router.push("/Login")
                        this.sessionData('clean','token');
                        this.resetSetItem('avatar','https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg');
                        this.resetSetItem('userName','未登录');
                    },
                    onCancel () {
                    }
                })
            },
            goToPersonal() {
                this.$router.push("/Account/AccountInfo")
                this.pageContent = 'personal'
                this.currentMenu = 'MyProject'
                this.currentType = 4
            },
            queryPersonalInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/enterprise', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.personalData = response.data.data
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error);
                })
            },
            goProductCommunity() {
                window.open('https://ask.ixiaowen.net/', '_blank');
            },
            goRecycleBin(item) {
                this.currentMenu = item
                this.resetSetItem('currentMenu',item);
                this.$router.push('/recycleBin')
            },
            goMyPro(item) {
                this.currentMenu = item
                this.resetSetItem('currentMenu',item);
                this.$router.push('/MyProject')
                window.location.reload()
            },
            viewDetailGpt(data) {
                this.$router.push({
                    path:'/GptDetail',
                    query: {
                        id: data
                    }
                })
                this.currentSelectId = data
                sessionStorage.setItem('currentSelectId', data)
                window.location.reload()
            }
        },
        mounted: function () {
            if(sessionStorage.getItem('currentMenu')){
                this.currentMenu = sessionStorage.getItem('currentMenu')
            }else{
                this.currentMenu = 'MyProject'
            }
            if(sessionStorage.getItem('currentSelectTab')){
                this.currentSelectTab = sessionStorage.getItem('currentSelectTab')
            }else{
                this.currentSelectTab = 'myAttention'
            }
            this.queryBasicInfo()
            this.queryAllProList(false)
            this.queryAllProList(true)
            this.queryPersonalInfo()
            this.currentSelectId = sessionStorage.getItem('currentSelectId')
        },
        updated() {
            document.title = this.pageTitle;
            const favicon = document.getElementById('dynamic-favicon');
            favicon.href = this.faviconIcon
        }
    }
</script>
<style lang="less" >
    .nav-component{
        position: relative;
        position: fixed;
        width: 100%;
        background: #fff;
        z-index: 100;
        height: 100%;
        display: flex;
        .left-menu{
            width: 240px;
            overflow: hidden;
            border-right: 1px solid rgba(229, 231, 235, 1);
            padding: 16px 0 0 0;
            display: flex;
            flex-direction: column;
            .headlogo{
                text-align: center;
                margin-bottom: 22px;
                img{
                    width: 130px;
                }
            }
            .menu-list{
                width: 100%;
                height: 40px;
                cursor: pointer;
                line-height: 40px;
                padding-left: 8px;
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
                i{
                    margin-right: 8px;
                }
            }
            
            .menu-divider{
                margin: 16px 0;
                background: rgba(229, 229, 229, 1);
            }
            .menu-box{
                flex: 1;
                overflow-y: auto;
                .menu-tab{
                    // margin-top: 16px;
                    color: rgba(158, 172, 196, 1);
                    font-size: 14px;
                    color:rgba(18, 18, 18, 1);
                    padding-left: 8px;
                    height: 40px;
                    line-height: 40px;
                    cursor: pointer;
                    i{
                        margin-right: 8px;
                    }
                    span:nth-child(2){
                        margin-right: 8px;
                    }
                }
                .menu-tab-list{
                    margin-left: 8px;
                    color: #505050;
                }
                ul{
                    // margin-top: 8px;
                    li{
                        font-size: 14px;
                        padding-left: 38px;
                        line-height: 30px;
                        cursor: pointer;
                        margin-bottom: 8px;
                        color: #121212;
                    }
                    li:hover{
                        background: rgba(229,231,235,0.3);
                    }
                }
                .current-active{
                    color: #22d7bb  !important
                }
            }
            .login-out{
                height: 60px;
                position: relative;
                .login-img{
                    float: left;
                    width: 44px;
                    height: 44px;
                    border-radius: 22px;
                }
                .login-info{
                    float: left;
                    margin-left: 10px;
                    color: rgba(18, 18, 18, 1);
                    font-size: 14px;
                    margin-top: 10px;
                }
                .login-icon{
                    float: right;
                    margin-top: 13px;
                    margin-right: 10px;
                }
                .personal-menu{
                    z-index: 100000;
                    position: absolute;
                    width: 112px;
                    height: 148px;
                    right: -112px;
                    top: -104px;
                    background: #fff;
                    display: none;
                    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
                    padding: 4px 0;
                    li{
                        padding: 0 16px;
                        height: 35px;
                        line-height: 35px;
                        cursor: pointer;
                        color: rgba(18, 18, 18, 1);
                        a{
                            color: rgba(18, 18, 18, 1);
                            display: inline-block;
                            width: 100%;
                            height: 100%;
                        }
                        i{
                            margin-right: 4px;
                        }
                    }
                    .personal-divider{
                        margin: 0px;
                    }
                    li:hover{
                        background: #FAFAFA;
                    }
                }
            }
            .login-out:hover{
                .personal-menu{
                    display: inline-block;
                }
            }
            .personal-info{
                .personal-logo{
                    text-align: center;
                    margin: 22px 0 32px;
                    .login-img{
                        width: 66px;
                        height: 66px;
                        border-radius: 33px;
                    }
                }
                .self-info{
                    text-align: center;
                    margin-bottom: 32px;
                    div:nth-child(1){
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                        font-weight: bold;
                        margin-bottom: 4px;
                    }
                    div:nth-child(2){
                        color: rgba(158, 172, 196, 1);
                        font-size: 12px;
                    }
                }
                .account-info{
                    height: 40px;
                    background: #E8FBF8;
                    border-right: 4px solid rgba(34, 215, 187, 1);
                    line-height: 40px;
                    padding-left: 30px;
                    font-size: 14px;
                    color: rgba(34, 215, 187, 1);
                    i{
                        margin-right: 8px;
                    }
                }
            }
        }
        .right-body{
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 100%;
            min-width: 1300px;
            .head-title{
                height: 50px;
                border-bottom: 1px solid rgba(229, 231, 235, 1);
                line-height: 50px;
                padding-left: 16px;
                .head-title-list{
                    color: rgba(158, 172, 196, 1);
                    font-size: 12px;
                    display: inline-block;
                    cursor: pointer;
                    i{
                        margin-right: 8px;
                    }
                }
            }
            .body-content{
                flex: 1;
                overflow-y: auto;
                background: rgba(250, 250, 250, 1);
            }
        }
    }
    .active-menu{
        height: 40px;
        line-height: 40px;
        background: rgba(34, 215, 187, 0.08) !important;
        color: rgba(34, 215, 187, 1) !important;
    }
    /*ie滚动条样式*/  
    * {  
        scrollbar-arrow-color: rgb(200,200,200);/*ok-上下三角箭头*/  
        scrollbar-3dlight-color: rgb(200,200,200);/*ok-3d滑块左上角高光部分颜色*/  
        scrollbar-highlight-color: rgb(200,200,200);/*ok-滑块左上角高光部分颜色*/  
        scrollbar-shadow-color: rgb(200,200,200);/*ok*/  
        scrollbar-darkshadow-color: rgb(200,200,200);/*ok-以上都是定义一些阴影高光等3D效果*/  
        scrollbar-face-color: rgb(200,200,200);/*ok-滑块*/  
        scrollbar-track-color: rgb(240,240,240);/*ok-滑道*/  
    }  
    /*chrome滚动条样式*/  
    ::-webkit-scrollbar {/*滚动条整体部分，其中的属性有width,height,background,border（就和一个块级元素一样）等。*/  
        width: 5px;  
        height: 5px;  
    }  
    ::-webkit-scrollbar-button {/*滚动条两端的按钮。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/  
        display: none;  
    }  
    ::-webkit-scrollbar-track {/*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/  
        display: none;  
    }  
    ::-webkit-scrollbar-track-piece {/*内层轨道，滚动条中间部分（除去）。*/  
        background: rgb(240,240,240);  
    }  
    ::-webkit-scrollbar-thumb {/*滚动条里面可以拖动的那部分*/  
        background: rgb(200,200,200);  
    }  
    ::-webkit-scrollbar-thumb:hover {/*滚动条里面可以拖动的那部分*/  
        background: rgb(180,180,180);  
    }  
    ::-webkit-scrollbar-corner {/*边角*/  
        background: rgb(200,200,200);  
    }  
    ::-webkit-scrollbar-resizer {/*定义右下角拖动块的样式*/  
        background: rgb(200,200,200);  
    } 
    .train label.ant-checkbox-wrapper{
        display: block !important;
        padding: 5px 0 4px 10px;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }
    .train label:nth-child(odd){
        background: rgba(238, 238, 238, 0.5);
    }
    .untrain label.ant-checkbox-wrapper{
        display: block !important;
        padding: 5px 0 4px 10px;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }
    .untrain label:nth-child(odd){
        background: rgba(238, 238, 238, 0.5);
    }
    .ant-tabs-nav .ant-tabs-tab{
        padding: 12px 0  !important;
    }
    .ant-tabs-tab:hover{
        color: rgba(34, 215, 187, 1) !important;
    }
    .ant-checkbox-checked .ant-checkbox-inner{
        background-color: rgba(34, 215, 187, 1) !important;
        border-color: rgba(34, 215, 187, 1) !important;
    }
    .ant-tabs-ink-bar{
        background-color: rgba(34, 215, 187, 1);
    }
    .ant-tabs-nav .ant-tabs-tab-active{
        color: rgba(34, 215, 187, 1);
    }
    @media only screen and (max-width: 770px) {
        .ant-modal-content .ant-modal-body{
            padding:0px !important;
            overflow: hidden;
        }
        .ant-modal-content{
            margin: 0 24px !important;
        }
        .ant-modal-close{
            display: none;
        }
    }
    .checkbox-list label.ant-checkbox-wrapper{
        width: 30%;
        margin-bottom: 12px;
    }
</style>